import React from 'react';

// Loading skeleton component
export const Skeleton = ({ className = '', variant = 'text' }) => {
  const baseClasses = 'animate-pulse bg-gray-200 rounded';
  const variantClasses = {
    text: 'h-4 w-full',
    circular: 'rounded-full',
    rectangular: 'rounded-md',
  };
  
  return <div className={`${baseClasses} ${variantClasses[variant] || ''} ${className}`} />;
};

// Card skeleton for market cards
export const CardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-sm p-4 space-y-3 dark:bg-slate-900/80">
    <Skeleton className="h-6 w-3/4" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-5/6" />
    <div className="flex gap-2 pt-2">
      <Skeleton className="h-10 flex-1" variant="rectangular" />
      <Skeleton className="h-10 flex-1" variant="rectangular" />
    </div>
  </div>
);

// Table row skeleton
export const TableRowSkeleton = ({ columns = 5 }) => (
  <tr className="animate-pulse">
    {Array(columns).fill(0).map((_, i) => (
      <td key={i} className="px-4 py-3">
        <Skeleton className="h-4" />
      </td>
    ))}
  </tr>
);

// Stats card skeleton
export const StatsCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-sm p-4 space-y-2 dark:bg-slate-900/80">
    <Skeleton className="h-8 w-8 rounded-full" variant="circular" />
    <Skeleton className="h-8 w-16" />
    <Skeleton className="h-4 w-24" />
  </div>
);

export default Skeleton;
